/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { GeometergeschaeftNummerSearchRequestMeta } from './geometergeschaeftNummerSearchRequestMeta';
import { AvMutationsNummerRequestMeta } from './avMutationsNummerRequestMeta';
import { GeometerRechtsgueltigHaengigOptionMeta } from './geometerRechtsgueltigHaengigOptionMeta';


export interface GeometergeschaeftSearchRequestMeta { 
    avMutationsNummer?: AvMutationsNummerRequestMeta;
    mAvMutationsNummer?: FieldMetaData;
    geschaeftsTyp?: GeometergeschaeftSearchRequestMeta.GeschaeftsTypEnum;
    mGeschaeftsTyp?: FieldMetaData;
    status?: GeometerRechtsgueltigHaengigOptionMeta;
    mStatus?: FieldMetaData;
    verarbeitungsArt?: GeometergeschaeftSearchRequestMeta.VerarbeitungsArtEnum;
    mVerarbeitungsArt?: FieldMetaData;
    geometerGeschaeft?: GeometergeschaeftNummerSearchRequestMeta;
    mGeometerGeschaeft?: FieldMetaData;
    geschaeftsTypList?: Array<GeometergeschaeftSearchRequestMeta.GeschaeftsTypListEnum>;
    mGeschaeftsTypList?: FieldMetaData;
    beschreibung?: string;
    mBeschreibung?: FieldMetaData;
}
export namespace GeometergeschaeftSearchRequestMeta {
    export type GeschaeftsTypEnum = 'DEFAULT_OHNE_GRUNDBUCH' | 'DEFAULT_MIT_GRUNDBUCH';
    export const GeschaeftsTypEnum = {
        DEFAULT_OHNE_GRUNDBUCH: 'DEFAULT_OHNE_GRUNDBUCH' as GeschaeftsTypEnum,
        DEFAULT_MIT_GRUNDBUCH: 'DEFAULT_MIT_GRUNDBUCH' as GeschaeftsTypEnum
    };
    export type VerarbeitungsArtEnum = 'STANDARD' | 'LANDUMLEGUNG' | 'FLAECHENBERICHTIGUNG' | 'ERSTERHEBUNG_ERNEUERUNG' | 'AV_BEMERKUNG';
    export const VerarbeitungsArtEnum = {
        STANDARD: 'STANDARD' as VerarbeitungsArtEnum,
        LANDUMLEGUNG: 'LANDUMLEGUNG' as VerarbeitungsArtEnum,
        FLAECHENBERICHTIGUNG: 'FLAECHENBERICHTIGUNG' as VerarbeitungsArtEnum,
        ERSTERHEBUNG_ERNEUERUNG: 'ERSTERHEBUNG_ERNEUERUNG' as VerarbeitungsArtEnum,
        AV_BEMERKUNG: 'AV_BEMERKUNG' as VerarbeitungsArtEnum
    };
    export type GeschaeftsTypListEnum = 'DEFAULT_OHNE_GRUNDBUCH' | 'DEFAULT_MIT_GRUNDBUCH';
    export const GeschaeftsTypListEnum = {
        DEFAULT_OHNE_GRUNDBUCH: 'DEFAULT_OHNE_GRUNDBUCH' as GeschaeftsTypListEnum,
        DEFAULT_MIT_GRUNDBUCH: 'DEFAULT_MIT_GRUNDBUCH' as GeschaeftsTypListEnum
    };
}


